
{
  "cta": "Order Now",
  "empty-title": "Menu Item",
  "errors": {
    "load": "Unable to load item"
  }
}
